import {GET_USER_ADDRESSES} from 'queries/addresses';
import {GET_USER_DETAILS} from 'queries/userDetails';
import {
  CREATE_USER_ADDRESS,
  GET_MEMBERSHIP_CARDS_WITH_POINTS,
  GET_STORE_AREAS,
  UPDATE_USER_ADDRESS
} from 'services/user/constants/queries';
import {
  AddressTypeEnum,
  CreateAddressInputType,
  CreateUserAddressResponse,
  IDefaultUserAddressesResponse,
  IUserProfile,
  StoreAreas,
  UpdateAddressInputType,
  UpdateUserAddressResponse
} from 'types';
import {MembershipCard} from 'types/membership';
import {userApolloClient, userApolloClientWithToken} from 'utils/apollo';

export async function createUserAddress(
  idToken: string,
  createAddressInput: CreateAddressInputType
): Promise<{data: CreateUserAddressResponse} | Record<string, any>> {
  const client = userApolloClientWithToken(idToken);
  const response = await client.mutate<CreateUserAddressResponse>({
    mutation: CREATE_USER_ADDRESS,
    variables: {
      createAddressInput
    }
  });
  return response;
}

export async function updateUserAddress(
  idToken: string,
  addressId: string,
  updateAddressInput: UpdateAddressInputType,
  addressType?: AddressTypeEnum
): Promise<{data: UpdateUserAddressResponse} | Record<string, any>> {
  // To do: input values should not be created in this function this should be in sagas
  const {id: _, ...addressInput} = updateAddressInput;
  const client = userApolloClientWithToken(idToken);
  const response = await client.mutate<UpdateUserAddressResponse>({
    mutation: UPDATE_USER_ADDRESS,
    variables: {
      addressId,
      updateAddressInput: addressInput,
      addressType
    }
  });
  return response;
}

export async function getStoreAreas(
  filter?: Partial<StoreAreas>,
  suggestion?: Partial<StoreAreas>,
  pageNo?: number,
  pageLength?: number
): Promise<{
  data: {
    getStoreAreas: StoreAreas[];
  };
}> {
  const response = await userApolloClient.query<{getStoreAreas: StoreAreas[]}>({
    query: GET_STORE_AREAS,
    variables: {
      filter,
      suggestion,
      pageNo,
      pageLength
    }
  });
  return response;
}

export async function getMakroMembershipCardsv2(idToken: string): Promise<Array<MembershipCard>> {
  const client = userApolloClientWithToken(idToken);
  const {data} = await client.query<{
    getMakroMembershipCards: MembershipCard[];
  }>({
    query: GET_MEMBERSHIP_CARDS_WITH_POINTS,
    variables: {
      accessToken: idToken
    }
  });

  return data?.getMakroMembershipCards;
}

export async function getUserAddresses(
  idToken?: string,
  addressType?: AddressTypeEnum
): Promise<{data: IDefaultUserAddressesResponse}> {
  const userApolloClient = userApolloClientWithToken(idToken as string);
  return await userApolloClient.query<IDefaultUserAddressesResponse>({
    query: GET_USER_ADDRESSES,
    variables: {
      addressType
    }
  });
}

export async function getUserDetails(idToken?: string): Promise<{data: IUserProfile}> {
  const userApolloClient = userApolloClientWithToken(idToken as string);
  return await userApolloClient.query<IUserProfile>({
    query: GET_USER_DETAILS
  });
}
